module.exports = __webpack_public_path__ + "static/media/hold-mobile-pix.003125be.png";